import Image from 'next/image'

import Box from '@ilg-totallymoney/ui/components/Box'
import Flex from '@ilg-totallymoney/ui/components/Flex'
import Heading from '@ilg-totallymoney/ui/components/Heading'
import Row from '@ilg-totallymoney/ui/components/Row'
import Stack from '@ilg-totallymoney/ui/components/Stack'
import Text from '@ilg-totallymoney/ui/components/Text'
import Icon from '@ilg-totallymoney/ui/icons/Icon'
import theme from '@ilg-totallymoney/ui/theme'

import TotallySureDetailsImage from '@images/credit-cards-landing-page-totallysure-details-image.png'

import LandingPageButton from '../LandingPageButton'

const detailsSectionMap: { copy: string; title: string }[] = [
    {
        title: 'Pre-approval',
        copy: 'The closest you can get to a yes, before you apply*',
    },
    {
        title: 'Guaranteed credit limit',
        copy: 'Know how much you can spend overall',
    },
    {
        title: 'Guaranteed rate',
        copy: 'Know what interest you’ll pay each month',
    },
    {
        title: 'Guaranteed offer duration',
        copy: 'Know how long any 0% interest periods will last',
    },
]

const LandingPageDetailsSection = () => (
    <section>
        <Flex justifyContent="center" mb={['space20', 'space60']}>
            <Heading variant="100" textAlign="center">
                Be TotallySure, exclusive to TotallyMoney
            </Heading>
        </Flex>

        <Stack
            space={['space40', 'space30']}
            direction={['column', 'row']}
            justifyContent={['center', 'space-evenly']}
            mb={[0, 'space50']}
        >
            <Stack space={['space30', 'space30', 'space40']}>
                <Text
                    variant="120"
                    weight="bold"
                    color="light"
                    textAlign={['center', 'left']}
                >
                    TotallySure offers come with pre-approval and guarantees.
                </Text>

                {detailsSectionMap.map(({ copy, title }, i: number) => (
                    <Row
                        key={`${title}-${i}`}
                        space="space20"
                        alignItems="center"
                    >
                        <Flex
                            alignSelf={['flex-start', 'center']}
                            aria-disabled="true"
                        >
                            <Icon
                                size={32}
                                icon="guaranteed"
                                title={`guaranteed bullet ${i}`}
                                color={theme['eligibilityLevel0-100']}
                            />
                        </Flex>

                        <Stack space="space05">
                            <Heading variant="40">{title}</Heading>
                            <Text color="light">{copy}</Text>
                        </Stack>
                    </Row>
                ))}

                <Box display={['flex', 'none']} justifyContent="center">
                    <LandingPageButton
                        title="See card offers"
                        variant="primary"
                    />
                </Box>
            </Stack>

            <Flex justifyContent="center">
                <Box
                    maxWidth={['320px', '416px']}
                    width={['100%', '300px', '416px']}
                    alignSelf="center"
                >
                    <Image
                        src={TotallySureDetailsImage}
                        alt="TotallySure offers on TotallyMoney"
                        quality={80}
                        sizes={`(max-width: ${theme.small}) 30vw, 60vw`}
                        placeholder="empty"
                        style={{
                            objectFit: 'contain',
                            position: 'relative',
                            width: '100%',
                            height: 'auto',
                        }}
                    />
                </Box>
            </Flex>
        </Stack>

        <Box display={['none', 'flex']} justifyContent="center">
            <LandingPageButton title="See card offers" variant="primary" />
        </Box>
    </section>
)

export default LandingPageDetailsSection
